"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultsPortal = void 0;
var joi_1 = __importDefault(require("joi"));
var other_1 = require("./other");
var detail_1 = require("./detail");
var lender_1 = require("./lender");
var history_1 = require("./history");
var operation_1 = require("./operation");
var grossDebtServiceTotalDebtService_1 = require("./grossDebtServiceTotalDebtService");
var managementInformation_1 = require("./managementInformation");
var borrower_1 = require("./borrower");
var asset_1 = require("./asset");
var liability_1 = require("./liability");
var mortgageObligation_1 = require("./mortgageObligation");
var financialObligation_1 = require("./financialObligation");
var attachment_1 = require("./attachment");
exports.defaultsPortal = joi_1.default.object({
    other: other_1.other,
    detail: detail_1.detail,
    lender: lender_1.lender,
    history: history_1.history,
    operation: operation_1.operation,
    grossDebtServiceTotalDebtService: grossDebtServiceTotalDebtService_1.grossDebtServiceTotalDebtService,
    managementInformation: managementInformation_1.managementInformation,
    borrower: joi_1.default.array()
        .items(borrower_1.borrower)
        .max(10),
    asset: joi_1.default.array().items(asset_1.asset),
    liability: joi_1.default.array().items(liability_1.liability),
    mortgageObligation: joi_1.default.array().items(mortgageObligation_1.mortgageObligation),
    financialObligation: joi_1.default.array().items(financialObligation_1.financialObligation),
    attachment: joi_1.default.array().items(attachment_1.attachment),
});
